import styled from 'styled-components';

export const CodesContainer = styled.div<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  ${({ $expanded }) => ($expanded ? 'flex-wrap: wrap;' : '')}
`;

export const CodesInner = styled.div`
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
`;

export const CodeChip = styled.span`
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 0.85rem;
  font-weight: 500;
`;

export const ExpandLink = styled.span`
  font-size: 0.85rem;
  color: #0286db;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
  font-weight: 500;
`;

export const BlankRect = styled.span`
  display: inline-block;
  width: 2rem;
  height: 1rem;
  background-color: #e0e0e0;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 4px;
  margin-right: 4px;
`;
